
import styled from 'styled-components'
import { PiChatsFill } from "react-icons/pi";
import { useTranslation } from 'react-i18next'


function NoConvSelected() {
  const { t } = useTranslation('messaging')
  return (
    <NoConvSelectedWrap>

        <PiChatsFill />
        <span>{t('conversation.select')}</span>

    </NoConvSelectedWrap>
  )
}

export default NoConvSelected

const NoConvSelectedWrap = styled.div`
    height: 100%;
    width: 100%; 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--lightThemeFontColor);
    svg{
        font-size: 3rem;
        margin-bottom: 20px;
    }
`
